import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "leaderboards",
  "use": "leaderboards-usage",
  "viewBox": "0 0 19 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 13\" id=\"leaderboards\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.334 2a2 2 0 012-2h3.335a2 2 0 012 2v5.112h3.334a2 2 0 012 2v3.446h-2V9.112h-3.335v3.446h-2V2H7.335v10.558h-2V6.445H2v6.112H0V6.445a2 2 0 012-2h3.334V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol